/* eslint-disable no-empty-pattern */
import { Field } from 'formik';
import React from 'react';
import { CustomAttributeField } from './CustomAttributeField';
import { Wrapper } from './CustomAttributes.Styles';
export var CustomAttributes = function (_a) {
    return (React.createElement(Wrapper, null,
        React.createElement(Field, { component: CustomAttributeField, name: 'customAttributes' })));
};
CustomAttributes.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CustomAttributes.js.map